/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OfferRejectionReason } from './OfferRejectionReason';
import {
    OfferRejectionReasonFromJSON,
    OfferRejectionReasonFromJSONTyped,
    OfferRejectionReasonToJSON,
} from './OfferRejectionReason';
import type { OfferTerminationReason } from './OfferTerminationReason';
import {
    OfferTerminationReasonFromJSON,
    OfferTerminationReasonFromJSONTyped,
    OfferTerminationReasonToJSON,
} from './OfferTerminationReason';

/**
 * 
 * @export
 * @interface StatusReason
 */
export interface StatusReason {
}

/**
 * Check if a given object implements the StatusReason interface.
 */
export function instanceOfStatusReason(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StatusReasonFromJSON(json: any): StatusReason {
    return StatusReasonFromJSONTyped(json, false);
}

export function StatusReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatusReason {
    return json;
}

export function StatusReasonToJSON(value?: StatusReason | null): any {
    return value;
}

